import 'babel-polyfill';
import * as React from 'react';
import {Helmet} from 'react-helmet-async';

const Wrapper = ({children}) => (
  <React.Fragment>
    <Helmet>
      <meta charSet="utf-8" />
      <link
        rel="apple-touch-icon"
        sizes="196x196"
        href="https://pdstaticprod.cdn.planday.cloud/favicons/apphost/favicon196.png"
      />
      <link rel="icon" type="image/png" sizes="32x32" href="https://pdstaticprod.cdn.planday.cloud/favicons/apphost/favicon32.png" />
      <link rel="icon" type="image/png" sizes="128x128" href="https://pdstaticprod.cdn.planday.cloud/favicons/apphost/favicon128.png" />
      <link rel="icon" type="image/png" sizes="196x196" href="https://pdstaticprod.cdn.planday.cloud/favicons/apphost/favicon196.png" />
      <meta name="msapplication-TileColor" content="#2d89ef" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
    {children}
  </React.Fragment>
);
export default Wrapper;
